// extracted by css-extract-rspack-plugin
export default {"SavedViewsList":"Sidebar-module__SavedViewsList__qer5e","SidebarContainer":"Sidebar-module__SidebarContainer__rhc0H","sidebarFooter":"Sidebar-module__sidebarFooter__Y58jP"};